// assets/ecomific-region.js
// Thin wrapper: core (ecomific-region-core.js) owns all logic.
// This file ensures init guard only; no globals, no API.
// Load ecomific-region-core.js before this script.

(function () {
  'use strict';

  if (window.__ECOMIFIC_REGION_INIT__) {
    return;
  }
  window.__ECOMIFIC_REGION_INIT__ = true;

  // Core runs from ecomific-region-core.js (script order: core first).
  // No window.ecomificRegionState or window.ecomificRegion.
})();
